import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, reduxForm} from 'redux-form';
import {Badge, Button, ButtonToolbar, Col, Form, Glyphicon, Panel, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {DateField, formatDate, scrollToErrors, SelectField, TypeheadField} from '../form/form';
import {Date, Enums} from "../../utils";

const validate = (values, b, c) => {
	const errors = {};

	if (!values.walkDate) {
		errors.walkDate = 'Zadejte prosím datum vycházky'
	}

	if (!values.party || !values.party.partyId) {
		errors.party = {partyId: 'Vyberte prosím venčitele'}
	}

	if (!values.dog || !values.dog.dogId) {
		errors.dog = {dogId: 'Vyberte prosím psa'}
	}

	return errors
};

class WalkForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			legalNeeded: false
		};
	}

	render() {
		const {handleSubmit, initialValues, enums, submitting, onSaveWalk} = this.props;

		const statusOptions = [];
		statusOptions.push({label: 'Aktivní', value: 'ACTIVE'});
		statusOptions.push({label: 'Ukončená', value: 'FINISHED'});
		statusOptions.push({label: 'Smazaná', value: 'DELETED'});

		const dogOptions = Enums.createEnumItems(enums, Enums.getKey("dog"), true);

		return (
			<Form horizontal onSubmit={handleSubmit((values) => {
				return onSaveWalk(values)
			})} className="detail">
				<Row>
					<Col lg={8} lgOffset={2}>
						<Panel>
							<Panel.Heading>
								{initialValues.walkId ? <span>Vycházka <Badge className="pull-right">{initialValues.walkId}</Badge></span> : <span>Nová vycházka</span>}
							</Panel.Heading>
							<Panel.Body>
								<Row>
									<Col sm={10}>
										<Field label="Datum" name="walkDate" type="text" sizes={[3, 5]} maxDate={Date.today()}
											component={DateField} maxLength="12" format={formatDate}/>
										<Field label="Venčitel" name="partyId" type="select" component={TypeheadField} emptyText="..." sizes={[3, 9]}
											loadOptions={(i, c) => this.props.onFindParties(i, c, this.props.party)} searchPromptText={"Zadejte jméno"}/>
										<Field label="Pes" name="dogId" type="select" component={SelectField} emptyText="(vyberte)" sizes={[3, 5]}
											options={dogOptions}/>
									</Col>
								</Row>
								{initialValues.walkId && <Row className="divider">
									<Col sm={10}>
										<Field label="Stav" name="status" type="select" component={SelectField} options={statusOptions} sizes={[3, 5]}/>
									</Col>
								</Row>}
							</Panel.Body>
						</Panel>
					</Col>
				</Row>
				<Row>
					<Col>
						<ButtonToolbar className="text-center">
							<Link to={{pathname: "/" + (initialValues.walkId ? "vychazky/" + initialValues.walkId : "")}} className="btn btn-default"><Glyphicon glyph="remove"/> Storno</Link>
							<Button bsStyle="success" type="submit" disabled={submitting}><Glyphicon glyph="ok"/> {initialValues.walkId ? "Uložit změny" : "Založit vycházku"}</Button>
						</ButtonToolbar>
					</Col>
				</Row>
			</Form>
		)
	}
}

WalkForm = reduxForm({
	form: 'walk',
	validate,
	onSubmitFail: scrollToErrors,
})(WalkForm);

WalkForm.propTypes = {
	id: PropTypes.number,
	item: PropTypes.object.isRequired,
	party: PropTypes.object,
	dog: PropTypes.object,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onSaveWalk: PropTypes.func.isRequired,
	onFindParties: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default WalkForm



// WEBPACK FOOTER //
// ./src/components/walk/WalkForm.js